import { useEffect } from "react";

export default function MoyasarPaymentInit({amount, description, pubKey, onPaid, callbackUrl}){
  useEffect(()=>{
    if(typeof window.Moyasar==="undefined"||!pubKey)return;
    try{
      window.Moyasar.init({
        element:".mysr-form",
        amount,
        currency:"SAR",
        description,
        publishable_api_key:pubKey,
        callback_url:callbackUrl||window.location.href,
        methods:["creditcard","applepay","stcpay"],
        apple_pay:{
          country:"SA",
          label:description||"Payment",
          validate_merchant_url:"https://api.moyasar.com/v1/applepay/initiate",
        },
        on_completed:(payment)=>{
          /* When callbackUrl is set, Moyasar will redirect the page after payment.
             Do NOT call onPaid here — the server-side callback handles workspace creation.
             Only call onPaid for in-page completions (no redirect). */
          if(!callbackUrl)onPaid(payment.id);
        },
      });
    }catch(e){console.warn("Moyasar init error",e);}
    /* Fallback: listen for custom event (non-redirect completions only) */
    const handler=(e)=>{if(!callbackUrl)onPaid(e.detail.id);};
    document.addEventListener("moyasar_paid",handler);
    return()=>document.removeEventListener("moyasar_paid",handler);
  },[callbackUrl]);
  if(typeof window.Moyasar==="undefined"||!pubKey){
    return(
      <div style={{textAlign:"center",padding:"24px 0"}}>
        <div style={{fontSize:13,color:"rgba(255,255,255,.4)",marginBottom:12}}>Payment widget not loaded.</div>
        <div style={{fontSize:11,color:"rgba(255,255,255,.25)"}}>Moyasar publishable key is not set in Platform API Keys.</div>
      </div>
    );
  }
  return null;
}
